import script from "./ChatMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMessage.vue?vue&type=style&index=0&id=41aac9c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41aac9c6"]])

export default __exports__